import { ActionCreatorWithPayload, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Nullable } from "../../../utils/nullable";

export interface IBasicInfo {
  "projectName": string;
  "projectDescription": string;
  "purpose": string;
  "country": string;
  "countryCode": string;
  "targetAudience": string;
  "businessFunction": string;
  "projectCategory": string[];
  "projectCategory-Comment": string;
  "projectOwner": string[];
  "techStack": string[];
  "techStack-Comment": string;
  "teamId": string;
  "teamName": string;
  "hasMnpi": Nullable<boolean>;
  "hasPii": Nullable<boolean>;
  "hasSensitivePii": Nullable<boolean>;
  "billingProjectId"?: Nullable<string>;
  "billingProjectName"?: Nullable<string>;
}

export interface IInfraConfig {
  isCodeRepositoryNeeded: string;
  isCiCdPipelineNeeded: string;
  githubOrganisation: string;
  isHostingServiceNeeded: string;
  gcpProjectName: string;
  gcpProjects: Array<{ name: string }>;
  comment: string;
}

export type IOthersFormData = {
  basicInfo: IBasicInfo;
  infraConfig: IInfraConfig;
};

export const othersInitialState: IOthersFormData = {
  basicInfo: {
    projectName: "",
    projectDescription: "",
    country: "",
    countryCode: "",
    targetAudience: "",
    businessFunction: "",
    projectCategory: [],
    "projectCategory-Comment": "",
    projectOwner: [],
    techStack: [],
    "techStack-Comment": "",
    teamId: "",
    teamName: "",
    purpose: "",
    hasMnpi: null,
    hasPii: null,
    hasSensitivePii: null,
  },
  infraConfig: {
    isCodeRepositoryNeeded: "",
    githubOrganisation: "",
    isCiCdPipelineNeeded: "",
    isHostingServiceNeeded: "",
    gcpProjectName: "",
    gcpProjects: [],
    comment: "",
  },
};

const othersSlice = createSlice({
  name: "getStartedPage/others",
  initialState: othersInitialState,
  reducers: {
    updateInfraConfig: (state: IOthersFormData, action: PayloadAction<Partial<IInfraConfig>>) => {
      state.infraConfig = {
        ...state.infraConfig,
        ...action.payload,
      };
    },
    updateBasicInfo: (state: IOthersFormData, action: PayloadAction<Partial<IBasicInfo>>) => {
      state.basicInfo = {
        ...state.basicInfo,
        ...action.payload,
      };
    },
  },
});

export const othersReducer = othersSlice.reducer;

const updateInfraConfig: ActionCreatorWithPayload<Partial<IInfraConfig>>
    = othersSlice.actions.updateInfraConfig;

const updateBasicInfo: ActionCreatorWithPayload<Partial<IBasicInfo>>
    = othersSlice.actions.updateBasicInfo;

export const OthersCategoryActions = {
  updateInfraConfig,
  updateBasicInfo,
};
